import { render, staticRenderFns } from "./NewPlayer.vue?vue&type=template&id=2a0be3c0&"
import script from "./NewPlayer.vue?vue&type=script&lang=js&"
export * from "./NewPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports